import { Component } from '@angular/core';

@Component({
  selector: 'app-logo-designs',
  templateUrl: './logo-designs.component.html',
  styleUrl: './logo-designs.component.scss'
})
export class LogoDesignsComponent {

}
